import OrganizationList from './OrganizationList'
//import OrganizationSearch from './OrganizationSearch'
import numberFormat from './dataviz/libraries/numberFormat'

const plugin = {
  install: Vue => {
    Vue.component(OrganizationList.name, OrganizationList)
    //Vue.component(OrganizationSearch.name, OrganizationSearch)
    Vue.filter('numberFormat', numberFormat)
  }
}

Vue.use(plugin)
